export { sidecar } from './hoc';
export { useSidecar } from './hook';
export { setConfig } from './config';
export { createMedium, createSidecarMedium } from './medium';
export { renderCar } from './renderProp';
export { exportSidecar } from './exports';



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-sidecar/dist/es2015/index.js
// module id = 227
// module chunks = 0